<template>
    <div v-if="showBanner" class="text-sm flex items-center justify-center gap-4 px-4 py-2">
        <Icon name="rocket-launch" class="text-lg" />
        <span>Source, review, export. Now easier than ever!</span>
        <Button size="xs" variant="accent" fill="solid" @click="onTryClick">Try our new BOM Tool</Button>
    </div>
</template>
<script setup lang="ts">
const { bomVersion, setBOMVersion } = useBomVersion();
const globalConfig = useStateGlobalConfig();

const emit = defineEmits<{ change: [] }>();

const showBanner = computed(() => globalConfig.value.Features.BOM_V2 && bomVersion.value !== "v2");

function onTryClick() {
    setBOMVersion("v2");
    emit("change");
}
</script>
